import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dropboxImagenDisplay'
})


export class DropboxImagenDisplayPipe implements PipeTransform {
    
    transform(url: string, type: string = ''): any {
        let urlProcesada:string;
        let aux:string[];
        let aux2:string[];
        
        if(url.length > 0 ){
            if( url.includes('dropbox') && url.includes('dl=0') ){

                /*
                    https://www.dropbox.com/scl/fi/zyt7lkn0zmoe7cd1xhhe0/20230811090604.png?rlkey=0ab5nsyxzlbsdse83kwyuysk1&dl=0
                */
                /*
                    aux = url.split('dl=0');
                    urlProcesada = aux[0] + 'raw=1';
                    
                    urlProcesada = url.replace('dl=0', 'raw=1');
                */
                
                // urlProcesada = url.replace('https://www.dropbox.com', 'https://dl.dropboxusercontent.com');
                urlProcesada = url.replace('https://www.dropbox.com', 'https://dl.dropbox.com');
            }else{
                urlProcesada = url;
            }
        }else{
            switch (type) {
                case "equipo":
                case "team":
                    urlProcesada = 'assets/img/utils/noimge.png';
                    break;
                case "person":
                case "persona":
                case "jugador":
                case "user":
                    urlProcesada = 'assets/img/utils/noimgp.png';
                    break;
                case "loading":
                    urlProcesada = 'assets/img/utils/load_b.gif';
                    break;
                case "loading_c":
                    urlProcesada = 'assets/img/utils/load_c.gif';
                    break;
                case "image_m":
                case "generalm_m":
                    urlProcesada = 'assets/img/utils/noimgg_m.jpg';
                    break;
                case "none":
                    urlProcesada = '';
                    break;
                default:
                    urlProcesada = 'assets/img/utils/noimgg.jpeg';
                    break;
            }
        }
        return urlProcesada;
    }

}
